<template>
    <main class="layout-intro">
        
        <transition appear name="fade">
            <div class="video-wrapper">
                <Video
                    class="video"
                    :autoplay="true"
                    :controls="false"
                    :loop="true"
                    video_mp4="https://gmri-ccil.s3.amazonaws.com/xdm/prod/media/content/asset/aquarium-plankton-video/tank-idle-plankton.mp4" />
            </div>
        </transition>
        <div class="wrapper">
            <div class="logo"></div>
            <transition appear name="fade">
                <h1>{{ $t("wv_home_01") }}</h1>
            </transition>

            <transition appear name="fade">
                <div>
                    <p class="delay-500">{{ $t("wv_home_02")}}</p>
                    <p class="delay-500 small">For more information on our offerings for Maine classrooms, please see the <a href="https://www.gmri.org/science-education/home-delivery" target="_blank">GMRI Home Delivery</a> webpage.</p>
                </div>
            </transition>

            <transition appear name="fade">
                <div class="mt-2 delay-1000">
                    <router-link :to="{name: 'about'}" class="about">
                        About LabVenture <IconArrow class="prompt-arrow" />
                    </router-link>
                </div>
            </transition>
        </div>
    </main>
</template>

<script>
import IconArrow from '@/assets/svg/icon-arrow-link.svg'

import Nav from '@/components/meta/Nav'
import Video from '@/components/common/Video'

export default {
    name: 'Home',
    components: {
        IconArrow,
        Nav,
        Video
    },
    head: {
        title: {
            inner: 'LabVenture',
            separator: '|',
            complement: 'GMRI.org'
        },
        meta: function() {
            return [
                {name: 'description', content: this.description},

                {property: 'og:title', content: 'LabVenture | Gulf of Maine Research Institute'},
                {property: 'og:description', content: this.description},
                {property: 'og:type', content: 'website'},
                {property: 'og:locale', content: 'en_us'},
                {property: 'og:image', content: `${window.location.origin}/img/previews/00_homepage.jpg`},

                {rel: 'canonical', href: window.location.href}
            ]
        }
    },
    async mounted() {
        await this.$store.dispatch("global/setNavState", 'home')
        this.$announcer.set(this.$t("wv_home_01"));
    }
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/_vars.scss";

.video-wrapper {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}

.video {
  position: absolute;
  width: auto;
  height: auto;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}


</style>
